import { objectCloneOmit } from './object-clone-omit';
export const objectWithout = objectCloneOmit;